import {
  elementInitialFontsizeOffsets,
  elementInitialLineHeightOffsets,
} from 'styles/updateGlobalFontStylesFromTheme';

export const preprocessTypeSettings = theme => {
  const {
    fontFamily,
    fontFamilies,
    fontSize,
    textColor,
    lineHeight,
    links,
  } = theme;

  let type;

  if (!lineHeight || !fontSize) {
    type = 'basic';
  } else {
    type =
      fontSize !== 16 || (lineHeight !== undefined && lineHeight !== 1.5)
        ? 'advanced'
        : 'basic';
  }

  const updatedLineHeight = Math.round((lineHeight || 1.5) * fontSize);

  const getElementInitialFontSize = h => ({
    fontSize: 16 * elementInitialFontsizeOffsets[h],
  });

  const getElementInitialLineheight = h => {
    const value = (lineHeight || 1.5) * 16 * elementInitialLineHeightOffsets[h];

    return {
      lineHeight: value,
    };
  };

  const typeSettings = {
    type: theme?.typeSettings?.type || type,
    fontFamily: theme?.typeSettings?.fontFamily || fontFamily,
    fontFamilies: theme?.typeSettings?.fontFamilies || fontFamilies,
    fontSize: theme?.typeSettings?.fontSize || fontSize,
    color: theme?.typeSettings?.color || textColor,
    lineHeight: theme?.typeSettings?.lineHeight || updatedLineHeight,
    links: theme?.typeSettings?.links || links,
    elementStyles: theme?.typeSettings?.elementStyles || {
      ...(type === 'advanced'
        ? {
            p: {
              fontSize,
              lineHeight: updatedLineHeight,
            },
            h1: {
              ...getElementInitialFontSize('h1'),
              ...getElementInitialLineheight('h1'),
            },
            h2: {
              ...getElementInitialFontSize('h2'),
              ...getElementInitialLineheight('h2'),
            },
            h3: {
              ...getElementInitialFontSize('h3'),
              ...getElementInitialLineheight('h3'),
            },
            h4: {
              ...getElementInitialFontSize('h4'),
              ...getElementInitialLineheight('h4'),
            },
            h5: {
              ...getElementInitialFontSize('h5'),
              ...getElementInitialLineheight('h5'),
              bold: true,
            },
            h6: {
              ...getElementInitialFontSize('h6'),
              ...getElementInitialLineheight('h6'),
              bold: true,
            },
          }
        : {
            h5: {
              bold: true,
            },
            h6: {
              bold: true,
            },
          }),
    },
  };

  console.log({ typeSettings });

  return typeSettings;
};
